/**
 * QuickNote Surface Component
 * Peek surface for quick note taking
 */

import React, { useState } from 'react';
import { Stack, Text, Textarea, Group, Button, Badge, Paper } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';

interface QuickNoteProps {
  phase?: number;
}

const QuickNote: React.FC<QuickNoteProps> = ({ phase = 1 }) => {
  const [note, setNote] = useState('');

  const handleSave = () => {
    console.log('Quick note saved:', note);
    setNote('');
  };

  return (
    <Stack gap="md" p="sm">
      <Group justify="space-between" align="center">
        <Text fw={600} size="sm">Quick Note</Text>
        <Badge size="xs" variant="light">Phase {phase}</Badge>
      </Group>

      <Paper p="md" radius="md" withBorder>
        <Textarea
          placeholder="Type a quick note..."
          value={note}
          onChange={(e) => setNote(e.currentTarget.value)}
          minRows={8}
          autosize
          variant="unstyled"
        />
      </Paper>

      <Group justify="flex-end">
        <Button
          size="xs"
          leftSection={<IconDeviceFloppy size={14} />}
          onClick={handleSave}
          disabled={!note.trim()}
        >
          Save
        </Button>
      </Group>
    </Stack>
  );
};

export default QuickNote;